import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Sparkles, Crown, ArrowLeft, ShieldCheck, Check } from "lucide-react";
import PremiumPaymentModal from "@/components/app/PremiumPaymentModal";

export default function PremiumPaywall({ featureName = "Fitur Premium", description = "Fitur ini khusus tersedia untuk pengguna Paket Premium." }) {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="min-h-[80vh] flex items-center justify-center p-4 md:p-8" data-testid="premium-paywall">
      <Card className="max-w-xl w-full p-6 md:p-8 rounded-3xl border border-border/80 bg-card/95 backdrop-blur-xl shadow-xl text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-amber-50 dark:bg-amber-950/50 border border-amber-200 dark:border-amber-800 flex items-center justify-center text-amber-600 dark:text-amber-400 shadow-inner">
          <Crown className="h-8 w-8" />
        </div>

        <div className="space-y-2">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300">
            <Sparkles className="h-3.5 w-3.5" /> Khusus Paket Premium
          </div>
          <h2 className="font-serif text-2xl md:text-3xl font-semibold text-foreground">
            Akses {featureName} Terkunci
          </h2>
          <p className="text-sm text-muted-foreground max-w-md mx-auto leading-relaxed">
            {description} Upgrade ke Paket Premium 1 Tahun untuk membuka akses penuh ke {featureName} dan seluruh fitur tanpa batas Weddly.
          </p>
        </div>

        <div className="bg-muted/50 rounded-2xl p-4 text-left space-y-2 text-xs border border-border/60">
          <p className="font-semibold text-foreground mb-2">Yang Anda dapatkan di Paket Premium (Rp 45.000 / Tahun):</p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-emerald-600 shrink-0" />
              <span>Undangan Digital Publik</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-emerald-600 shrink-0" />
              <span>Moodboard Perencanaan</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-emerald-600 shrink-0" />
              <span>34 Template Tugas Checklist</span>
            </div>
            <div className="flex items-center gap-2 text-muted-foreground">
              <Check className="h-4 w-4 text-emerald-600 shrink-0" />
              <span>Weddly AI Assistant</span>
            </div>
          </div>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button
            onClick={() => setModalOpen(true)}
            className="w-full sm:w-auto h-11 rounded-full px-6 bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 text-white font-medium shadow-md transition-all"
            data-testid="upgrade-premium-btn"
          >
            <ShieldCheck className="mr-2 h-4 w-4" /> Upgrade ke Premium (Rp 45.000)
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate("/dashboard")}
            className="w-full sm:w-auto h-11 rounded-full px-6"
          >
            <ArrowLeft className="mr-2 h-4 w-4" /> Kembali ke Dashboard
          </Button>
        </div>
      </Card>

      <PremiumPaymentModal
        open={modalOpen}
        onOpenChange={setModalOpen}
        onSuccess={() => {
          window.location.reload();
        }}
      />
    </div>
  );
}
